import { render, staticRenderFns } from "./Maracatu.vue?vue&type=template&id=25d092be&scoped=true&lang=pug&"
import script from "./Maracatu.vue?vue&type=script&lang=js&"
export * from "./Maracatu.vue?vue&type=script&lang=js&"
import style0 from "./Maracatu.vue?vue&type=style&index=0&id=25d092be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d092be",
  null
  
)

export default component.exports
import {QPage,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QBtn})
